/* eslint-disable @typescript-eslint/no-explicit-any */
export const CHILD_GROUP_MOCK: any[] = [
  {
    id: "G0BQV1AOLQ",
    name: "Southampton",
    parent: "G0PZG1KTR7",
    domain: "southampton-11plus",
    sort_key: "X1731025776080",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8466.png",
      },
    },
    banner: {
      type: "image",
      data: {
        url: "https://images5.alphacoders.com/116/1166309.png",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025776080,
    users_count: 10,
    deactivated_users_count: 1,
    sub_groups_count: 0,
    url: "https://southampton-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CKRJW7JIU",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CKRJW7JIU",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CKRJW7JIU",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040733,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMSUT10U3YU", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1732395916987,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733135235178,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CKRJW7JIU",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G09215242G",
    name: "Ipswich Town",
    parent: "G0PZG1KTR7",
    domain: "ipswichtown-11plus",
    sort_key: "X1731025697194",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-9902.png",
      },
    },
    banner: {
      type: "image",
      data: {
        url: "https://flagsireland.com/cdn/shop/files/Ipswich_Town_Football_Club_Flag.png?v=1720184610",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025697194,
    users_count: 2,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://ipswichtown-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "C0LLQEWQH",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C0LLQEWQH",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C0LLQEWQH",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040733,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMR5XGU0HA4", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025697194,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733190906155,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "C0LLQEWQH",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G08ERH1549",
    name: "Leicester City",
    parent: "G0PZG1KTR7",
    domain: "leicestercity-11plus",
    sort_key: "X1731025622519",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8197.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#6300ffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025622519,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://leicestercity-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CHIPN8OY9",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CHIPN8OY9",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CHIPN8OY9",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040750,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMPKCQXX5MN", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025622519,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731025623946,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CHIPN8OY9",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0J6MGOLUG",
    name: "Nottingham Forest",
    parent: "G0PZG1KTR7",
    domain: "nottinghamforest-11plus",
    sort_key: "X1731025545758",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-10203.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#00f498ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025545759,
    users_count: 1,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://nottinghamforest-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CHN1VY1BW",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CHN1VY1BW",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CHN1VY1BW",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040750,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMNX8VLV8FU", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025545759,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1732001788436,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CHN1VY1BW",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G06Y9XDE8M",
    name: "Brentford",
    parent: "G0PZG1KTR7",
    domain: "brentford-11plus",
    sort_key: "X1731025471978",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-9937.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#6300ffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025471978,
    users_count: 2,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://brentford-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CPM34NEWP",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CPM34NEWP",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CPM34NEWP",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040750,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMMC16RXR5N", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025471978,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731990422916,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CPM34NEWP",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G08W5S1QHO",
    name: "Everton",
    parent: "G0PZG1KTR7",
    domain: "everton-11plus",
    sort_key: "X1731025409870",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8668.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#c01dffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025409870,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://everton-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "C6GXV9KR8",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C6GXV9KR8",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C6GXV9KR8",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040751,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUML0D21O0P5", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025409870,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731025410810,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "C6GXV9KR8",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0SNLOF0H7",
    name: "Wolverhampton Wanderers",
    parent: "G0PZG1KTR7",
    domain: "wolverhamptonwanderers-11plus",
    sort_key: "X1731025337822",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8602.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff00f4ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025337822,
    users_count: 1,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://wolverhamptonwanderers-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CSJI5RY38",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CSJI5RY38",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CSJI5RY38",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040751,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMJGSEE9YRW", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025337822,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731922703331,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CSJI5RY38",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0SX8JE85B",
    name: "Fulham",
    parent: "G0PZG1KTR7",
    domain: "fulham-11plus",
    sort_key: "X1731025289208",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-9879.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff00a5ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025289208,
    users_count: 4,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://fulham-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "C4HGE0PBL",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C4HGE0PBL",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C4HGE0PBL",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040751,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMIF95PPIZ2", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025289208,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733815774456,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "C4HGE0PBL",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G09NI8R4AR",
    name: "AFC Bournemouth",
    parent: "G0PZG1KTR7",
    domain: "afcbournemouth-11plus",
    sort_key: "X1731025226851",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8678.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff00a5ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025226852,
    users_count: 1,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://afcbournemouth-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CTV6S6S4J",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CTV6S6S4J",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CTV6S6S4J",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040751,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMH357OQNP1", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025226852,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731980660531,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CTV6S6S4J",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0X5L1ZNQ7",
    name: "Brighton & Hove Albion",
    parent: "G0PZG1KTR7",
    domain: "brightonandhovealbion-11plus",
    sort_key: "X1731025144822",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-10204.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#00f498ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025144822,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://brightonandhovealbion-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "C55PMWKA8",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C55PMWKA8",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C55PMWKA8",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040751,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMFBYHUJC49", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025144822,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731025145810,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "C55PMWKA8",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0TDF5AFUM",
    name: "Crystal Palace",
    parent: "G0PZG1KTR7",
    domain: "crystalpalace-11plus",
    sort_key: "X1731025085502",
    icon: {
      type: "text",
      data: {
        text: "C",
        color: "#ffffffff",
        bg_color: "#00e9ffff",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#00e9ffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025085502,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://crystalpalace-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CO207YAO8",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CO207YAO8",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CO207YAO8",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040752,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUME24XN7H0C", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025085502,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731025086408,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CO207YAO8",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G083NTTW13",
    name: "West Ham United",
    parent: "G0PZG1KTR7",
    domain: "westhamunited-11plus",
    sort_key: "X1731025026367",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8654.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#3e00ffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731025026367,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://westhamunited-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CRYDXS3XD",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CRYDXS3XD",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CRYDXS3XD",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040752,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMCSKFV5TNO", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731025026367,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731025027919,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CRYDXS3XD",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G08JJW6OZ1",
    name: "Newcastle United",
    parent: "G0PZG1KTR7",
    domain: "newcastleunited-11plus",
    sort_key: "X1731024964749",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-10261.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff0050ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024964749,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://newcastleunited-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CWQB0N5XK",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CWQB0N5XK",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CWQB0N5XK",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040752,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUMBH10O6PA4", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731024964749,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731024965439,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CWQB0N5XK",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0ZLGBV4X3",
    name: "Chelsea",
    parent: "G0PZG1KTR7",
    domain: "chelsea-11plus",
    sort_key: "X1731024890932",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8455.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff0050ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024890932,
    users_count: 1,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://chelsea-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CPX2QQ0WB",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CPX2QQ0WB",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CPX2QQ0WB",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040752,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUM9VVVNFZTH", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731024890932,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1732456588651,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CPX2QQ0WB",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0WS7WMYPI",
    name: "Tottenham Hotspur",
    parent: "G0PZG1KTR7",
    domain: "tottenhamhotspur-11plus",
    sort_key: "X1731024831071",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8586.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff0050ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024831071,
    users_count: 5,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://tottenhamhotspur-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "C1WJY3ONO",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C1WJY3ONO",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "C1WJY3ONO",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040753,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUM8LVK2WIQO", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731024831071,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733060785376,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "C1WJY3ONO",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G06NS4TOPA",
    name: "Aston Villa",
    parent: "G0PZG1KTR7",
    domain: "astonvilla-11plus",
    sort_key: "X1731024771836",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-10252.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#6300ffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024771836,
    users_count: 0,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://astonvilla-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CPWGPABNN",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CPWGPABNN",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CPWGPABNN",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040753,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUM7C0DYVNJK", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731024771836,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1731024772554,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CPWGPABNN",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G0CNWSVU3B",
    name: "Liverpool",
    parent: "G0PZG1KTR7",
    domain: "liverpool-11plus",
    sort_key: "X1731024718516",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8650.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#00f406ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024718516,
    users_count: 4,
    deactivated_users_count: 1,
    sub_groups_count: 0,
    url: "https://liverpool-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CVF1YNB6G",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CVF1YNB6G",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CVF1YNB6G",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040753,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUM66TMAV2K7", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1732455932370,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733058720180,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CVF1YNB6G",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G009C235NF",
    name: "Arsenal",
    parent: "G0PZG1KTR7",
    domain: "arsenal-11plus",
    sort_key: "X1731024669402",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-9825.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#8c1dffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024669402,
    users_count: 5,
    deactivated_users_count: 0,
    sub_groups_count: 0,
    url: "https://arsenal-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CA75JUNEN",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CA75JUNEN",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CA75JUNEN",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040753,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUM556JY2JBL", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731024669402,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733979633595,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CA75JUNEN",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G03O38G9LF",
    name: "Manchester City",
    parent: "G0PZG1KTR7",
    domain: "manchestercity-11plus",
    sort_key: "X1731024614502",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-8456.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#ff00a5ff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1731024614503,
    users_count: 3,
    deactivated_users_count: 1,
    sub_groups_count: 0,
    url: "https://manchestercity-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CSQQW65NP",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CSQQW65NP",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CSQQW65NP",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040753,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YUM3Y6A97VF4", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1731024614503,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1733191986328,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CSQQW65NP",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
  {
    id: "G07PNQ7JJM",
    name: "Manchester United",
    parent: "G0PZG1KTR7",
    domain: "manchesterunited-11plus",
    sort_key: "X1730973438647",
    icon: {
      type: "image",
      data: {
        url: "https://files.vingle.network/files/G0PZG1KTR7/team-logo/team-10260.png",
      },
    },
    banner: {
      type: "color",
      data: {
        color: "#3e00ffff",
      },
    },
    is_public: true,
    is_hub: false,
    created_at: 1730973438648,
    users_count: 4,
    deactivated_users_count: 1,
    sub_groups_count: 0,
    url: "https://manchesterunited-11plus.vingle.network",
    profile_blocks_Config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    available_profile_blocks_config: {
      show: [
        {
          target: "all",
          block: {
            type: "positions",
            chipSize: "medium",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            badgeSize: "medium",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
      preview: [
        {
          target: "all",
          block: {
            type: "positions",
            maxLine: 3,
            chipSize: "small",
          },
        },
        {
          target: "all",
          block: {
            type: "badges",
            maxLine: 1,
            badgeSize: "small",
            showTitle: true,
          },
        },
        {
          target: "all",
          block: {
            type: "user-contents-list",
            userId: "{{user.id}}",
            children: [
              {
                type: "post",
              },
            ],
          },
        },
      ],
    },
    search_blocks_config: [
      {
        type: "search-histories",
        header: {},
      },
    ],
    customHtmlTags: [],
    default_channel: {
      type: "conversation",
      channel_id: "CGKV39YLK",
    },
    home: {
      app: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CGKV39YLK",
        },
      },
      web: {
        type: "channel",
        ref: {
          type: "conversation",
          id: "CGKV39YLK",
        },
      },
    },
    stat: {
      count: 0,
      has_new: true,
      has_new_notification: false,
      updated_at: 1734067040753,
      has_new_for_list: false,
      list_count: 0,
      root_list_count: 0,
    },
    sign_up_config_v2: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        sms: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        appPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        webPush: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        email: {
          nightTime: {
            state: "deactivated",
            isPrivate: false,
          },
          dayTime: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    sign_up_config: {
      signUpForm: {
        state: "deactivated",
        isPrivate: true,
      },
      subgroup: {
        state: "deactivated",
        isPrivate: false,
        min: 0,
        max: 3,
        childMoimGroupIds: [],
      },
      adAgreement: {
        dayTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
        nightTime: {
          app: {
            state: "deactivated",
            isPrivate: false,
          },
          email: {
            state: "deactivated",
            isPrivate: false,
          },
          sms: {
            state: "deactivated",
            isPrivate: false,
          },
        },
      },
      phone: {
        state: "deactivated",
        isPrivate: true,
      },
      referralCode: {
        state: "deactivated",
        isPrivate: false,
      },
      shippingAddress: {
        state: "deactivated",
        isPrivate: true,
      },
      profileImage: {
        state: "deactivated",
        isPrivate: false,
      },
    },
    config: {
      hideSortingOptions: false,
      useOnlyParentProfile: false,
      enableUsingSubSeller: false,
      enableUsingSubGroup: true,
      enableWeb3: true,
      enableNFT: false,
      contracts: [],
      enableDquest: true,
      enableCryptoBadge: true,
      enableCoin: true,
      enableCoinCard: false,
      enableCoinRecharge: false,
      enableTeamBuying: false,
      enableInAppPurchase: false,
      enableMessageSearch: true,
      enableDMmessageSearch: false,
      representativeNestedRepliesCount: 2,
      enableOpenReview: false,
      enableProductReviewRating: false,
      locales: ["ko", "en"],
      defaultLocale: "ko",
      fonts: {
        fontDefinitions: [
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Aoboshi One",
            url: "https://fonts.googleapis.com/css2?family=Aoboshi+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "East Sea Dokdo",
            url: "https://fonts.googleapis.com/css2?family=East+Sea+Dokdo&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gowun Dodum",
            url: "https://fonts.googleapis.com/css2?family=Gowun+Dodum&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Bagel Fat One",
            url: "https://fonts.googleapis.com/css2?family=Bagel+Fat+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Slabo 13px",
            url: "https://fonts.googleapis.com/css2?family=Slabo+13px&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Lato",
            url: "https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Black Han Sans",
            url: "https://fonts.googleapis.com/css2?family=Black+Han+Sans&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Stylish",
            url: "https://fonts.googleapis.com/css2?family=Stylish&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans KR",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Noto Sans JP",
            url: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "custom",
                  value: 1000,
                },
              },
            ],
            name: "Nunito Sans",
            url: "https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200;0,6..12,300;0,6..12,400;0,6..12,500;0,6..12,600;0,6..12,700;0,6..12,800;0,6..12,900;0,6..12,1000;1,6..12,200;1,6..12,300;1,6..12,400;1,6..12,500;1,6..12,600;1,6..12,700;1,6..12,800;1,6..12,900;1,6..12,1000&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Open sans",
            url: "https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "PT Sans",
            url: "https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Work Sans",
            url: "https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Dela Gothic One",
            url: "https://fonts.googleapis.com/css2?family=Dela+Gothic+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Gothic A1",
            url: "https://fonts.googleapis.com/css2?family=Gothic+A1:wght@100;200;300;400;500;600;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Gothic",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Nanum Gothic Coding",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Gothic+Coding:wght@400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
            ],
            name: "Nanum Myeongjo",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Myeongjo:wght@400;700;800&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Pen Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Pen+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Nanum Brush Script",
            url: "https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Grandiflora One",
            url: "https://fonts.googleapis.com/css2?family=Grandiflora+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Roboto",
            url: "https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Dongle",
            url: "https://fonts.googleapis.com/css2?family=Dongle:wght@300;400;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Gasoek One",
            url: "https://fonts.googleapis.com/css2?family=Gasoek+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Diphylleia",
            url: "https://fonts.googleapis.com/css2?family=Diphylleia&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Montserrat",
            url: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
            ],
            name: "Oswald",
            url: "https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Source Sans 3",
            url: "https://fonts.googleapis.com/css2?family=Source+Sans+3:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Raleway",
            url: "https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Merriweather",
            url: "https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Concert One",
            url: "https://fonts.googleapis.com/css2?family=Concert+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "italic",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Prompt",
            url: "https://fonts.googleapis.com/css2?family=Prompt:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "M PLUS 1p",
            url: "https://fonts.googleapis.com/css2?family=M+PLUS+1p:wght@100;300;400;500;700;800;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Zen Kaku Gothic New",
            url: "https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Kosugi",
            url: "https://fonts.googleapis.com/css2?family=Kosugi&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
            ],
            name: "Mochiy Pop One",
            url: "https://fonts.googleapis.com/css2?family=Mochiy+Pop+One&display=swap",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Thin.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraLight.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Light.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Regular.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Medium.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-SemiBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Bold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-ExtraBold.ttf",
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
                src: "https://moim-fonts.s3.amazonaws.com/Pretend/public/static/alternative/Pretendard-Black.ttf",
              },
            ],
            name: "Pretendard",
            url: "https://moim-fonts.s3.amazonaws.com/Pretend/web/variable/pretendardvariable.css",
          },
          {
            fontFaces: [
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "thin",
                  value: 100,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraLight",
                  value: 200,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "light",
                  value: 300,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "regular",
                  value: 400,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "medium",
                  value: 500,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "semiBold",
                  value: 600,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "bold",
                  value: 700,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "extraBold",
                  value: 800,
                },
              },
              {
                fontStyle: "normal",
                fontWeight: {
                  name: "black",
                  value: 900,
                },
              },
            ],
            name: "Hahmlet",
            url: "https://fonts.googleapis.com/css2?family=Hahmlet:wght@100..900&display=swap",
          },
        ],
      },
      showMemberCount: false,
      disableUserNameChange: false,
      enableLockContent: false,
      enableMeeting: false,
      theme: "LIGHT",
      theme_web: "LIGHT",
      needSignUpApproval: false,
      defaultTagGroups: {},
      enableCustomUserLogin: false,
      preferCustomUserLogin: false,
      forceExternalCanpassLogin: true,
    },
    analytics: {},
    tags: ["E3YTRN2W76WINB", "E3YSBGK2F8U72E"],
    joined: false,
    isPinned: false,
    latest_at: 1730973438648,
    sorting_options: [
      {
        sort: "sortKey",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "desc",
      },
      {
        sort: "createdAt",
        order: "asc",
      },
      {
        sort: "latestAt",
        order: "desc",
      },
      {
        sort: "latestAt",
        order: "asc",
      },
    ],
    navigation_config: {
      isIndependentChild: false,
      explorer: {
        items: [
          {
            type: "channel",
          },
          {
            type: "directMessage",
          },
        ],
      },
    },
    navigation_structure: {
      web: {
        topNavi: {
          showNavigation: true,
          elements: [
            {
              align: "left",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentGroupProfileElement",
                },
              ],
            },
            {
              minWidth: {
                type: "fixed",
                value: 140,
              },
              align: "center",
              size: {
                type: "ratio",
                value: 1,
              },
              type: "wrapperElement",
              children: [
                {
                  type: "searchElement",
                },
              ],
              maxWidth: {
                type: "fixed",
                value: 600,
              },
            },
            {
              align: "right",
              size: {
                type: "fit-contents",
              },
              type: "wrapperElement",
              children: [
                {
                  type: "currentUserElement",
                },
              ],
            },
          ],
        },
        topSubNavi: {
          showNavigation: false,
        },
        sideNavi: {
          showNavigation: false,
        },
      },
      app: {
        bottomNavi: {
          items: [
            {
              title: "Home",
              type: "home",
            },
            {
              title: "Channel",
              type: "explorer",
            },
            {
              title: "Me",
              type: "profile",
            },
          ],
          firstSelectedIndex: 0,
        },
      },
    },
    status_config: {
      type: "none",
      isEnabledStatus: false,
      enableScheduler: false,
      hideRemainTime: false,
    },
    updated_at: 1732526249638,
    internationalizations: [
      {
        regionCode: "KR",
        emojiU: "U+1F1F0 U+1F1F7",
        languages: ["ko"],
        emoji: "🇰🇷",
        native: "대한민국",
        countryCode: "82",
        name: "South Korea",
      },
    ],
    mobile_top_tabs: [
      {
        type: "channel",
        channelId: "CGKV39YLK",
      },
    ],
    search_tabs: ["post", "message", "member"],
    search_tabs_v2: [
      {
        type: "post",
        isActive: true,
      },
      {
        type: "message",
        isActive: true,
      },
      {
        type: "member",
        isActive: true,
      },
    ],
    event_noti_config: {
      phoneAuthentication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: true,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      contentsLockUnlock: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: true,
        },
        email: {
          active: false,
        },
      },
      onboarding: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
      rejectSignUpApplication: {
        kakaoTalk: {
          active: false,
        },
        sms: {
          active: false,
        },
        adminBot: {
          active: false,
        },
        communityBot: {
          active: false,
        },
        email: {
          active: false,
        },
      },
    },
  },
];
